<template>
  <div>
    <a-result
      title="准备跳转支付"
      :sub-title="'订单ID: ' + trade_id.split('-')[0]"
    >
      <template #icon>
        <a-icon type="alipay" />
      </template>
    </a-result>
    <div style="display: flex; justify-content: center;">
      <a-spin size="large"></a-spin>
    </div>
    <div v-html="payContent"></div>
  </div>
</template>

<script>
import { getDeviceTradePay } from '@/api/device'
var mobile = require('is-mobile')

export default {
  name: 'inAppTrade',
  data () {
    return {
      isMobile: mobile(),
      trade_id: '',
      payContent: ''
    }
  },
  methods: {
    getDeviceTradePay () {
      getDeviceTradePay({
        trade_id: this.trade_id,
        is_mobile: this.isMobile,
        is_tv: this.isTv
      }).then(res => {
        this.payContent = res.result.content
        setTimeout(() => {
          document.forms['alipay_submit'].submit()
        }, 500)
      })
    },
    initQuery () {
      if (typeof this.$route.query.trade_id === 'undefined') {
        return false
      }
      this.trade_id = this.$route.query.trade_id
    }
  },
  created () {
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = 'Zerofast'
  },
  mounted () {
    this.initQuery()
    this.getDeviceTradePay()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Trade.vue